import { CircularProgress, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';

import ModuleCard from './Module';
import SessionTabs from './SessionTabs';
import { Link } from 'react-router-dom';
import Cards from 'components/ui/Card';
import RunningCard from './Running';
import { useContext } from 'react';
import { BiRefresh } from 'react-icons/bi';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { trainingsubdomain } from 'redux/reducers/settings';
import { useGetTrainingRoutineQuery } from 'redux/reducers/user/dashboard';

const TmsDashboard: React.FC = () => {

  const {appConfig}=useContext(ConfigurationContext)

  // shares the cache entry with ModuleCard, so one refetch reloads the section
  const { isFetching: isOngoingFetching, refetch: refetchOngoing } =
    useGetTrainingRoutineQuery('active');


  return (
 <Box sx={{ width: '100%', marginTop: '8px', px: { xs: 2, md: 0 } }}> {/* Added horizontal padding for mobile */}
  <Grid container spacing={2} justifyContent="center">
    <Grid item xs={12} md={8}>
          <Box
            sx={{
              borderRadius: '10px',
              backgroundColor: 'white',
            }}
            
            padding={3}>
            <Box>
              <Typography sx={{ color: 'blak', fontSize: '18px' }}>Status</Typography>
            </Box>
            <Box marginY={4}>
              <Cards />
              
            </Box>
         
            <Grid container columnSpacing={3}>
              <Grid item xs={12}>
                <Box marginY={4}>
                  <Box
                    marginY={2}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <Link to={'/trainee/enroll'}>
                      <Typography sx={{ color: 'black', fontSize: '18px' }}>
                        On Going Training
                      </Typography>
                    </Link>
                    <Tooltip title="Reload ongoing training">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => refetchOngoing()}
                          disabled={isOngoingFetching}>
                          {isOngoingFetching ? (
                            <CircularProgress size={16} />
                          ) : (
                            <BiRefresh size={20} />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                  <ModuleCard />
                </Box>
              </Grid>
            </Grid>

            {appConfig?.domain_name===trainingsubdomain? <Grid container columnSpacing={3}>
              <Grid item xs={12}>
                <Box marginY={4}>
                  <Box marginY={2}>
                      <Typography sx={{ color: 'black', fontSize: '18px' }}>
                        Running Training
                      </Typography>
                  </Box>
                  <RunningCard />
                </Box>
              </Grid>
            </Grid>:''}
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <SessionTabs />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TmsDashboard;
